(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brass-cats-arch-collage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-polaroid-carousel]').forEach(function (carousel) {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';
    var viewport = carousel.querySelector('[data-carousel-viewport]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
    var previous = carousel.querySelector('[data-carousel-previous]');
    var next = carousel.querySelector('[data-carousel-next]');
    var timer;
    function scrollPhotos(direction) {
      var columns = [];
      slides.forEach(function (slide) {
        if (columns.indexOf(slide.offsetLeft) === -1) columns.push(slide.offsetLeft);
      });
      columns.sort(function (a, b) { return a - b; });
      var currentColumn = 0;
      columns.forEach(function (column, index) {
        if (column <= viewport.scrollLeft + 8) currentColumn = index;
      });
      var targetColumn = currentColumn + direction;
      if (targetColumn >= columns.length) targetColumn = 0;
      if (targetColumn < 0) targetColumn = columns.length - 1;
      viewport.scrollLeft = columns[targetColumn];
    }
    function restartAutoplay() {
      if (timer) window.clearInterval(timer);
      if (carousel.dataset.autoplay === 'true' && slides.length > 1) timer = window.setInterval(function () { scrollPhotos(1); }, Number(carousel.dataset.interval) || 5000);
    }
    if (slides.length < 2) { if (previous) previous.hidden = true; if (next) next.hidden = true; return; }
    if (previous) previous.addEventListener('click', function () { scrollPhotos(-1); restartAutoplay(); });
    if (next) next.addEventListener('click', function () { scrollPhotos(1); restartAutoplay(); });
    carousel.addEventListener('mouseenter', function () { if (timer) window.clearInterval(timer); });
    carousel.addEventListener('mouseleave', restartAutoplay);
    restartAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curio-all-products-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curio-catalog-carousel')) {
    customElements.define(
      'curio-catalog-carousel',
      class CurioCatalogCarousel extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;

          this.dataset.ready = 'true';
          this.track = this.querySelector('[data-curio-track]');
          this.previousButton = this.querySelector('[data-curio-previous]');
          this.nextButton = this.querySelector('[data-curio-next]');

          if (!this.track || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', () => this.move(-1));
          this.nextButton.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          window.addEventListener('resize', () => this.updateButtons(), { passive: true });
          this.updateButtons();
        }

        move(direction) {
          this.track.scrollBy({ left: this.track.clientWidth * 0.85 * direction, behavior: 'smooth' });
        }

        updateButtons() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          this.previousButton.disabled = this.track.scrollLeft <= 2;
          this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
